import { logErrorToFailureEvent } from './log-error-to-failure-event';

export { logErrorToFailureEvent };
